export class SearchAllRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "types",
            "baseName": "types",
            "type": "Array<SearchAllType>",
            "format": ""
        },
        {
            "name": "providers",
            "baseName": "providers",
            "type": "Array<Provider>",
            "format": ""
        },
        {
            "name": "filters",
            "baseName": "filters",
            "type": "string",
            "format": ""
        },
        {
            "name": "pageSize",
            "baseName": "pageSize",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllRequest.attributeTypeMap;
    }
    constructor() {
    }
}
